import {Appointment} from './appointment';
import {AppointmentType} from './appointment-type';
import {CalendarAppointment} from './calendar-appointment';
import {PracticePractitioner} from '../../practice-repository/entities/practice-practitioner';

/**
 * Build an Appointment write payload from a CalendarAppointment (read shape)
 * plus optional field overrides. Useful when acting on a calendar-loaded
 * appointment and needing to POST/PUT without refetching the full entity.
 *
 * `start`/`end` are pass-through: they are **zone-less wall-clock** both on read
 * and on write, so a non-time patch (assign patient, change status) re-sends the
 * same wall-clock unchanged. A patch that moves the appointment overrides
 * `start`/`end` with the new wall-clock (see `instantToWallClock`).
 */
export function calendarAppointmentToWriteModel(
  source: CalendarAppointment,
  patch: Partial<Appointment> = {}
): Appointment {
  return {
    id: source.id,
    title: source.title,
    comment: source.comment,
    start: source.start,
    end: source.end,
    practiceId: source.practiceId,
    appointmentType: source.appointmentType as unknown as AppointmentType,
    appointmentMetaData: source.metaData ?? {name: '', cell: '', email: ''},
    patient: undefined,
    patientId: source.patient?.id,
    practiceLocationId: source.location?.id,
    practicePractitionerId: source.practitioner?.id,
    practitioner: source.practitioner as unknown as PracticePractitioner,
    createdDate: source.createdDate,
    lastModifiedDate: source.lastModifiedDate,
    createdDateUtc: source.createdDateUtc,
    modifiedDateUtc: source.modifiedDateUtc,
    createdUser: source.createdUser,
    lastModifiedUser: source.lastModifiedUser,
    deleted: false,
    ...patch,
  };
}
